import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { PATH } from '../app.api'
import { CompanyServiceProvider, CompanyServiceProviderListParams } from '../models/CompanyServiceProvider'

@Injectable()
export class CompanyServiceProviderService {
	constructor(private http: HttpClient) {}

	public editCompanyServiceProvider(companyServiceProviderId: string, companyId: string, company: CompanyServiceProvider): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.patch<any>(`${PATH}/companyServiceProvider/${companyServiceProviderId}/company/${companyId}`, JSON.stringify(company), { headers: options })
	}

	public newCompanyServiceProvider(companyId: string, company: CompanyServiceProvider) {
		const options: HttpHeaders = this.setHeader()

		return this.http.post<any>(`${PATH}/companyServiceProvider/company/${companyId}`, JSON.stringify(company), { headers: options })
	}

	public getCompaniesServiceProvider(params: CompanyServiceProviderListParams ) {
		const {
			companyId,
			skip,
			limit,
			order,
			typeOrder,
			handlerOperationIds
		} = params

		const options: HttpHeaders = this.setHeader()

		return this.http.get<any>(
			`${PATH}/companyServiceProvider/company/${companyId}?skip=${skip}&limit=${limit}&order=${order}&typeOrder=${typeOrder}${handlerOperationIds ? '&handlerOperationIds=' + handlerOperationIds : ''}`,
			{
				headers: options
			}
		).pipe(
			map(res => {
				return res.content
			})
		)
	}

	public getDetailCompanyServiceProvider(companyId: string, companyServiceProviderId: string) {
		const options: HttpHeaders = this.setHeader()

		return this.http.get<any>(`${PATH}/companyServiceProvider/${companyServiceProviderId}/company/${companyId}`, { headers: options }).pipe(
			map(res => {
				return res.content
			})
		)
	}

	public getHandlerOperations(companyId: string): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.get<any>(`${PATH}/companyServiceProvider/handler-operations/${companyId}`, { headers: options }).pipe(
			map(res => {
				return res.content
			})
		)
	}

	public removeCompanyServiceProvider(companyId: string, companyServiceProviderId: string) {
		const options: HttpHeaders = this.setHeader()

		return this.http.delete<any>(`${PATH}/companyServiceProvider/${companyServiceProviderId}/company/${companyId}`, { headers: options })
	}

		private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append( 'x-source-from', 'PAINEL')
	}
}
